import ServiceEvent from '../../Services/ServiceEvent';
import ServiceArticle from '../../Services/ServiceArticle';
import Service from '../../Services/Service';

const SearchAPI = {
    searchPrograms({ tag, keyword, page }) {
        page = page ? page : 1;
        return ServiceEvent.get(`/search-products/${tag}?keyword=${keyword}&page=${page}&per_page=10`);
    },
    searchArticles({ keyword, page }) {
        page = page ? page : 1;
        return ServiceArticle.get(`/get-all-articles?keyword=${keyword}&page=${page}&limit=10`);
    }
};
export default SearchAPI
